import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from '../../utils/api.services';

export const getCountryListApiCall = createAsyncThunk("countryList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: countryList } = await API.getCountryList(submitData);
        dispatch(setLoader(false))
        return countryList;
    } catch (error) {
        throw error;
    }
});

const initialState = {
    isLoading: false,
    countryList: {
        data: [],
        error: null,
    },
    isToggle : true
}

const masterSlice = createSlice({
    name: 'masterslice',
    initialState,
    reducers: {
        setLoader: (state, action) => {
            state.isLoading = action.payload;
        },
        setIs_Toggle: (state, action) => {
        console.log('action :', action);
            state.isToggle = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCountryListApiCall.fulfilled, (state, action) => {
                state.countryList.data = action.payload;
            })
            .addCase(getCountryListApiCall.rejected, (state, action) => {
                state.countryList.error = action.error.message;
            });
    },
});

export const { setLoader, setIs_Toggle } = masterSlice.actions;
export default masterSlice.reducer;